const EmployeeModelIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.2058 23.0061L22.9523 23.961C25.995 25.0188 29.3006 25.0503 32.3629 24.0507L35.7411 22.948C36.388 22.7368 37.0955 22.9956 37.4534 23.5744L39.1377 26.2979C39.4824 26.8553 39.6697 27.4956 39.6792 28.1509C39.68 28.2073 39.6804 28.2638 39.6804 28.3204V34.5495C39.6804 41.219 34.2737 46.6257 27.6042 46.6257C20.9346 46.6257 15.5278 41.219 15.5278 34.5495V28.3204C15.5278 28.2636 15.5282 28.2068 15.5291 28.15C15.5387 27.4892 15.7601 26.849 16.1603 26.3232L18.2323 23.6011C18.6922 22.9968 19.4885 22.7568 20.2058 23.0061Z"
        stroke="#027C80"
        strokeWidth="1.2109"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.6426 55.0584C29.8493 55.0584 32.5632 47.7671 33.2211 45.9025C33.2498 45.8212 33.3699 45.8426 33.3699 45.9288V50.1864C33.3699 50.7077 33.7243 51.1622 34.2299 51.2893L41.3266 53.0724C45.1368 54.0298 47.8081 57.4553 47.8081 61.3839V63.0018"
        stroke="#027C80"
        strokeWidth="1.2109"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.5659 55.0506C25.3675 55.0506 22.664 47.7593 22.0086 45.8947C21.98 45.8134 21.8604 45.8348 21.8604 45.921V50.1786C21.8604 50.6999 21.5073 51.1544 21.0036 51.2815L13.9339 53.0646C10.1382 54.0219 7.47705 57.4474 7.47705 61.3761V62.994"
        stroke="#027C80"
        strokeWidth="1.2109"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4871 51.6641C19.4871 51.6641 22.1777 59.6863 27.5554 59.6863C32.9331 59.6863 35.7101 51.6641 35.7101 51.6641"
        stroke="#027C80"
        strokeWidth="1.2109"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.4441 28.263V20.8685C41.4441 19.805 40.5819 18.9428 39.5184 18.9428C38.835 18.9428 38.281 18.3888 38.281 17.7054C38.281 14.3775 35.5832 11.6797 32.2553 11.6797H25.8465C19.1314 11.6797 13.6877 17.1233 13.6877 23.8384V27.9563"
        stroke="#027C80"
        strokeWidth="1.2109"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.6451 27.7109C42.0103 27.7109 43.9277 29.4718 43.9277 31.644V32.3051C43.9277 34.4772 42.0103 36.2381 39.6451 36.2381H39.4619"
        stroke="#027C80"
        strokeWidth="1.2109"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3518 27.7109C13.0777 27.7109 11.2341 29.4718 11.2341 31.644V32.3051C11.2341 34.4772 13.0777 36.2381 15.3518 36.2381H15.5279"
        stroke="#027C80"
        strokeWidth="1.2109"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.9094 3.09472L52.3335 3.5637C52.5728 3.82826 52.9449 3.92798 53.2844 3.81849L53.8862 3.6244C54.7968 3.33073 55.7618 3.88786 55.9627 4.82329L56.0955 5.44151C56.1705 5.79026 56.4429 6.06268 56.7916 6.13761L57.4099 6.27042C58.3453 6.47138 58.9024 7.43638 58.6088 8.34696L58.4147 8.94876C58.3052 9.28825 58.4049 9.66039 58.6695 9.89965L59.1385 10.3238C59.8481 10.9655 59.8481 12.0798 59.1385 12.7216L58.6695 13.1457C58.4049 13.385 58.3052 13.7571 58.4147 14.0966L58.6088 14.6984C58.9024 15.609 58.3453 16.574 57.4099 16.7749L56.7916 16.9077C56.4429 16.9827 56.1705 17.2551 56.0955 17.6038L55.9627 18.222C55.7618 19.1575 54.7968 19.7146 53.8862 19.4209L53.2844 19.2268C52.9449 19.1174 52.5728 19.2171 52.3335 19.4816L51.9094 19.9506C51.2676 20.6602 50.1533 20.6602 49.5116 19.9506L49.0874 19.4816C48.8482 19.2171 48.476 19.1174 48.1365 19.2268L47.5347 19.4209C46.6241 19.7146 45.6592 19.1575 45.4582 18.222L45.3254 17.6038C45.2504 17.2551 44.978 16.9827 44.6293 16.9077L44.011 16.7749C43.0756 16.574 42.5185 15.609 42.8121 14.6984L43.0062 14.0966C43.1157 13.7571 43.016 13.385 42.7514 13.1457L42.2825 12.7216C41.5728 12.0798 41.5728 10.9655 42.2825 10.3238L42.7514 9.89965C43.016 9.66039 43.1157 9.28825 43.0062 8.94876L42.8121 8.34696C42.5185 7.43638 43.0756 6.47138 44.011 6.27042L44.6293 6.13761C44.978 6.06268 45.2504 5.79026 45.3254 5.44151L45.4582 4.82329C45.6592 3.88786 46.6241 3.33073 47.5347 3.6244L48.1365 3.81849C48.476 3.92798 48.8482 3.82826 49.0874 3.5637L49.5116 3.09472C50.1533 2.38509 51.2676 2.38509 51.9094 3.09472Z"
        stroke="#06AEB3"
        strokeWidth="1.2109"
        strokeMiterlimit="10"
      />
      <path
        d="M46.428 13.7132L47.4248 12.7164L49.3074 9.13086L49.5283 6.7392C49.5909 6.06053 50.2506 5.60251 50.9084 5.78093C51.3866 5.91064 51.7186 6.34466 51.7186 6.84013V9.57618H54.2026C54.8818 9.57618 55.406 10.1735 55.3178 10.8469L54.9872 13.372C54.9135 13.9352 54.4709 14.3788 53.9079 14.4538L50.2617 14.94L48.8816 16.0134"
        stroke="#06AEB3"
        strokeWidth="1.2109"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.9203 19.2891V24.6046L50.7273 23.7446L46.5002 24.6116V19.2891"
        stroke="#06AEB3"
        strokeWidth="1.2109"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.69058 41.9375L9.95746 45.3612L13.3812 46.6281L9.95746 47.8949L8.69058 51.3186L7.4237 47.8949L4 46.6281L7.4237 45.3612L8.69058 41.9375Z"
        stroke="#06AEB3"
        strokeWidth="1.2109"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7804 1L14.0473 4.42368L17.471 5.69055L14.0473 6.95743L12.7804 10.3811L11.5135 6.95743L8.08984 5.69055L11.5135 4.42368L12.7804 1Z"
        stroke="#FFA473"
        strokeWidth="1.2109"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.4979 28.2969L53.7648 31.7206L57.1885 32.9874L53.7648 34.2543L52.4979 37.678L51.2311 34.2543L47.8074 32.9874L51.2311 31.7206L52.4979 28.2969Z"
        stroke="#FFA473"
        strokeWidth="1.2109"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.6122 33.0037C34.6122 33.0037 33.0377 31.6243 31.1836 33.0037"
        stroke="#027C80"
        strokeWidth="1.2109"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.318 33.0037C24.318 33.0037 22.7436 31.6243 20.8894 33.0037"
        stroke="#027C80"
        strokeWidth="1.2109"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.1033 38.7891C26.1033 38.7891 27.6778 41.3932 29.5319 38.7891"
        stroke="#027C80"
        strokeWidth="1.2109"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EmployeeModelIcon;
